import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export var getUmiPackage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var umi, umiPkg, maxPkg;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          umi = null;
          _context.prev = 1;
          _context.next = 4;
          return require("umi");
        case 4:
          umiPkg = _context.sent;
          if (!umiPkg) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", umiPkg);
        case 7:
          _context.next = 11;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
        case 11:
          _context.prev = 11;
          _context.next = 14;
          return require("@umijs/max");
        case 14:
          maxPkg = _context.sent;
          if (!maxPkg) {
            _context.next = 18;
            break;
          }
          umi = maxPkg;
          return _context.abrupt("return", maxPkg);
        case 18:
          _context.next = 22;
          break;
        case 20:
          _context.prev = 20;
          _context.t1 = _context["catch"](11);
        case 22:
          return _context.abrupt("return", umi);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9], [11, 20]]);
  }));
  return function getUmiPackage() {
    return _ref.apply(this, arguments);
  };
}();